/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReadOriginalEmailApiResponse } from '../types/userContentApi.types';

export function transformReadOriginalEmail(
  response: any,
): ReadOriginalEmailApiResponse {
  return {
    data: response,
    meta: {},
  };
}
